import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { useMyContext } from '../../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaUser, FaUniversity } from "react-icons/fa";
import { Base_Url, Url_For_View_Document, accountUpdaterequest, resetuserpasswordapi } from '../../../config/config';
import { FaEye } from 'react-icons/fa'
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import {
  FaIdCard,
  FaAddressCard,
  FaTimes,
  FaEdit,
  FaSave,
} from 'react-icons/fa';

const ViewAllCustomer = ({ isopen, onClose, customer }) => {
  const { isDarkMode } = useMyContext();
  const [isEditMode, setIsEditMode] = useState(false);
  const [cancelledChequeFile, setCancelledChequeFile] = useState(null);
  const [mailScreenshotFile, setMailScreenshotFile] = useState(null);
  const [isResetMode, setIsResetMode] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onErrors = (errors) => {
    toast.error("Please fix the errors in the form.");
  };

  const handleResetPassword = async () => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+=\[\]{};':"\\|,.<>/?]).{8,}$/;

    if (!passwordRegex.test(password)) {
      toast.error("Password must be at least 8 characters long and include 1 uppercase letter and 1 special character.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(
        Base_Url + resetuserpasswordapi,
        {
          email: customer.email,
          password: password,
          c_password: confirmPassword,
        },
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        setIsResetMode(false);
        setPassword("");
        setConfirmPassword("");
        onClose();

      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("Failed to reset password.");
    }
  };

  useEffect(() => {
    if (customer) {
      reset({
        Id: customer.id || '',
        Name: customer.name || '',
        email: customer.email || '',
        phone: customer.phone || '',
        company_name: customer.company_name || '',
        company_type: customer.company_type || '',
        status: customer.status || '0',
        profile_flag: customer.profile_flag || '0',
        user_address_image: customer.user_address_image || '',
        user_pancard_image: customer.user_pancard_image || '',
        user_gst_image: customer.user_gst_image || '',
        aadhar_status: customer.aadhar_status || '0',
        pan_card_status: customer.pan_card_status || '0',
        gst_status: customer.gst_status || '0',
        aadhar_number: customer.aadhar_number || '',
        pancard_number: customer.pancard_number || '',
        gst_number: customer.gst_number || '',
        role: customer.role || '',
        txn_amount: customer.txn_amount || '',
        wallet_status: customer.wallet_status || '0',
        create_date: customer.create_date || '',
        timestamp: customer.timestamp || '',
        account_holder_name: customer.account_holder_name || '',
        account_no: customer.account_no || '',
        bank_name: customer.bank_name || '',
        ifsc_code: customer.ifsc_code || '',
      });
      setCancelledChequeFile(null);
      setMailScreenshotFile(null);
    }
  }, [customer, reset]);

  const handleFileChange = (event, setFileFunction) => {
    const file = event.target.files[0];
    if (file) {
      setFileFunction(file);
    }
  };

  const ViewDocument = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const handleClose = () => {
    setIsEditMode(false);
    setCancelledChequeFile(null);
    setMailScreenshotFile(null);
    onClose();
  };

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append('user_id', customer.id || '');
    formData.append('bank_name', data.bank_name || '');
    formData.append('ifsc_code', data.ifsc_code || '');
    formData.append('account_holder', data.account_holder_name || '');
    formData.append('account_no', data.account_no || '');

    if (cancelledChequeFile) {
      formData.append('cancel_check', cancelledChequeFile);
    }
    if (mailScreenshotFile) {
      formData.append('mail_screenshort', mailScreenshotFile);
    }
    try {
      const response = await axios.post(Base_Url + accountUpdaterequest, formData, {
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'multipart/form-data',

        },
      });

      if (response.data.status === "success") {
        toast.success(response.data.message);
        handleClose();
      } else {
        toast.error(response.data.message.cancel_check);
        toast.error(response.data.message.mail_screenshort);
        toast.error(response.data.message.bank_name);
        toast.error(response.data.message.account_holder);
      }
    } catch (error) {
      console.error('API Error:', error);
      toast.error('Failed to update account details');
    }
  };

  const inputClass = `p-1.5 text-[10px] border border-gray-300 dark:border-gray-700 w-full rounded focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 focus:border-gray-500 dark:focus:border-gray-400 bg-white dark:bg-black dark:text-white disabled:bg-gray-50 dark:disabled:bg-gray-900 disabled:text-gray-400 transition-all`;
  const labelClass = "block text-[9px] font-medium text-gray-500 dark:text-gray-400 mb-0.5 uppercase tracking-wider";
  const sectionClass = "p-2 rounded border border-gray-200 dark:border-gray-800";
  const sectionTitleClass = "text-[10px] font-semibold mb-2 text-gray-700 dark:text-gray-300 flex items-center uppercase tracking-wider gap-1.5";

  return (
    <Dialog
      open={isopen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: "rounded-lg overflow-hidden"
      }}
    >
      <DialogTitle className="bg-gray-800 dark:bg-white text-white dark:text-black relative py-2 px-4">
        <div className="flex items-center gap-2">
          <div className="p-1 rounded border border-white/20 dark:border-black/20">
            <FaUser size={12} className="text-white dark:text-black" />
          </div>
          <h2 className="text-[11px] font-semibold">Customer Details</h2>
        </div>
        <IoIosCloseCircle
          className="absolute top-2 right-3 cursor-pointer hover:opacity-70 transition-opacity"
          size={18}
          onClick={handleClose}
        />
      </DialogTitle>

      <DialogContent className="bg-white dark:bg-black custom-scrollbar p-0" style={{ maxHeight: '75vh' }}>
        <div className="py-3 px-4">
          <form className="space-y-2.5 font-sans" onSubmit={handleSubmit(onSubmit, onErrors)}>

            {/* Primary Information */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard size={11} />
                Primary Information
              </h3>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className={labelClass}>ID</label>
                  <input type="text" className={inputClass} {...register('Id')} disabled={!isEditMode} />
                </div>
                <div>
                  <label className={labelClass}>Name</label>
                  <input type="text" className={inputClass} {...register('Name')} disabled={!isEditMode} />
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaAddressCard size={11} />
                Contact Information
              </h3>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className={labelClass}>Email</label>
                  <input type="email" className={inputClass} {...register('email')} disabled={!isEditMode} />
                </div>
                <div>
                  <label className={labelClass}>Phone</label>
                  <input type="tel" className={inputClass} {...register('phone')} disabled={!isEditMode} />
                </div>
              </div>
            </div>

            {/* Company Information */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard size={11} />
                Company Information
              </h3>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className={labelClass}>Company Name</label>
                  <input type="text" className={inputClass} {...register('company_name')} disabled={!isEditMode} />
                </div>
                <div>
                  <label className={labelClass}>Company Type</label>
                  <input type="text" className={inputClass} {...register('company_type')} disabled={!isEditMode} />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2">
                <div>
                  <label className={labelClass}>GST Number</label>
                  <input type="text" className={inputClass} {...register('gst_number')} disabled={!isEditMode} />
                </div>
                <div>
                  <label className={labelClass}>Profile Status</label>
                  <select {...register('profile_flag')} className={inputClass} disabled={!isEditMode}>
                    <option value="0">User Unverified</option>
                    <option value="1">User Verified</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Password Management */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard size={11} />
                Password Management
              </h3>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className={labelClass}>New Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className={`${inputClass} pr-7`}
                      disabled={!isResetMode}
                      placeholder={isResetMode ? "Enter new password" : "Disabled"}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                    >
                      {showPassword ? <FiEyeOff size={13} /> : <FiEye size={13} />}
                    </span>
                  </div>
                </div>
                <div>
                  <label className={labelClass}>Confirm Password</label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className={`${inputClass} pr-7`}
                      disabled={!isResetMode}
                      placeholder={isResetMode ? "Confirm password" : "Disabled"}
                    />
                    <span
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                    >
                      {showConfirmPassword ? <FiEyeOff size={13} /> : <FiEye size={13} />}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Document Information */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard size={11} />
                Document Information
              </h3>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className={labelClass}>Aadhar Number</label>
                  <input type="text" className={inputClass} {...register('aadhar_number')} disabled={!isEditMode} />
                </div>
                <div>
                  <label className={labelClass}>PAN Number</label>
                  <input type="text" className={inputClass} {...register('pancard_number')} disabled={!isEditMode} />
                </div>
              </div>
              <div className="space-y-2 mt-2">
                <div>
                  <div className="flex items-center justify-between mb-0.5">
                    <label className={labelClass + " mb-0"}>Aadhar Card Image</label>
                    {customer?.user_address_image && (
                      <button
                        type="button"
                        className="text-[9px] text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white flex items-center gap-1"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_address_image)}
                      >
                        <FaEye size={10} /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input type="file" className="text-[10px] w-full" />
                  ) : (
                    <input type="text" {...register('user_address_image')} className={inputClass} disabled />
                  )}
                </div>
                <div>
                  <div className="flex items-center justify-between mb-0.5">
                    <label className={labelClass + " mb-0"}>PAN Card Image</label>
                    {customer?.user_pancard_image && (
                      <button
                        type="button"
                        className="text-[9px] text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white flex items-center gap-1"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_pancard_image)}
                      >
                        <FaEye size={10} /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input type="file" className="text-[10px] w-full" />
                  ) : (
                    <input type="text" {...register('user_pancard_image')} className={inputClass} disabled />
                  )}
                </div>
                <div>
                  <div className="flex items-center justify-between mb-0.5">
                    <label className={labelClass + " mb-0"}>GST Certificate</label>
                    {customer?.user_gst_image && (
                      <button
                        type="button"
                        className="text-[9px] text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white flex items-center gap-1"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_gst_image)}
                      >
                        <FaEye size={10} /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input type="file" className="text-[10px] w-full" />
                  ) : (
                    <input type="text" {...register('user_gst_image')} className={inputClass} disabled />
                  )}
                </div>
              </div>
            </div>

            {/* Bank Account Details */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaUniversity size={11} />
                Bank Account Details
              </h3>
              <p className="text-[9px] text-gray-400 dark:text-gray-500 mb-2 border border-gray-200 dark:border-gray-800 p-2 rounded">
                Ensure bank details are accurate for payment processing.
              </p>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className={labelClass}>Account Holder</label>
                  <input type="text" className={inputClass} {...register('account_holder_name')} disabled={!isEditMode} />
                </div>
                <div>
                  <label className={labelClass}>Bank Name</label>
                  <input type="text" className={inputClass} {...register('bank_name')} disabled={!isEditMode} />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2">
                <div>
                  <label className={labelClass}>Account Number</label>
                  <input type="text" className={inputClass} {...register('account_no')} disabled={!isEditMode} />
                </div>
                <div>
                  <label className={labelClass}>IFSC Code</label>
                  <input type="text" className={inputClass} {...register('ifsc_code')} disabled={!isEditMode} />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2">
                <div>
                  <div className="flex items-center justify-between mb-0.5">
                    <label className={labelClass + " mb-0"}>Cancelled Cheque</label>
                    {customer?.cancel_check_image && (
                      <button
                        type="button"
                        className="text-[9px] text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white flex items-center gap-1"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.cancel_check_image)}
                      >
                        <FaEye size={10} /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input type="file" onChange={(e) => handleFileChange(e, setCancelledChequeFile)} className="text-[10px] w-full" />
                  ) : (
                    <div className={inputClass + " bg-gray-50 dark:bg-gray-900 text-gray-400"}>
                      {customer?.cancel_check_image || 'No file uploaded'}
                    </div>
                  )}
                </div>
                <div>
                  <div className="flex items-center justify-between mb-0.5">
                    <label className={labelClass + " mb-0"}>Account Approval Mail</label>
                    {customer?.account_appruve_mail && (
                      <button
                        type="button"
                        className="text-[9px] text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white flex items-center gap-1"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.account_appruve_mail)}
                      >
                        <FaEye size={10} /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input type="file" onChange={(e) => handleFileChange(e, setMailScreenshotFile)} className="text-[10px] w-full" />
                  ) : (
                    <div className={inputClass + " bg-gray-50 dark:bg-gray-900 text-gray-400"}>
                      {customer?.account_appruve_mail || 'No file uploaded'}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap gap-2 pt-1 pb-1 border-t border-gray-200 dark:border-gray-800 pt-3">
              <button
                type="button"
                onClick={() => setIsEditMode(!isEditMode)}
                className="text-[10px] font-medium py-1.5 px-3.5 rounded border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all flex items-center gap-1.5"
              >
                {isEditMode ? (
                  <><FaTimes size={10} /> Cancel</>
                ) : (
                  <><FaEdit size={10} /> Edit</>
                )}
              </button>

              {isEditMode && (
                <button
                  type="submit"
                  className="text-[10px] font-medium py-1.5 px-3.5 rounded bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80 transition-all flex items-center gap-1.5"
                >
                  <FaSave size={10} /> Save
                </button>
              )}

              <button
                type="button"
                onClick={() => setIsResetMode(!isResetMode)}
                className="text-[10px] font-medium py-1.5 px-3.5 rounded border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all"
              >
                {isResetMode ? 'Cancel Reset' : 'Reset Password'}
              </button>

              {isResetMode && (
                <button
                  onClick={handleResetPassword}
                  className="text-[10px] font-medium py-1.5 px-3.5 rounded bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80 transition-all"
                  type="button"
                >
                  Confirm Reset
                </button>
              )}
            </div>

          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewAllCustomer;